module.exports = __webpack_public_path__ + "img/adriana.9bf0e5f8.jpg";